var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "package-wrapper", attrs: { id: "categories-wrapper" } },
    [
      _c(
        "b-card-group",
        { staticClass: "package-card-group mb-4", attrs: { columns: "" } },
        [
          _vm._l(_vm.local_record, function (_package, index) {
            return _c("b-card", { key: index }, [
              _c("div", { staticClass: "package-actions" }, [
                _vm.editings[_package.id] !== true
                  ? _c("i", {
                      staticClass: "fi-pencil",
                      on: {
                        click: function ($event) {
                          return _vm.editPackage(_package)
                        },
                      },
                    })
                  : _c("span", [
                      !!_package.id
                        ? _c("i", {
                            staticClass: "fi-trash",
                            on: {
                              click: function ($event) {
                                return _vm.deletePackage(_package.id)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fi-save",
                        on: {
                          click: function ($event) {
                            return _vm.savePackage(_package)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fi-x",
                        on: {
                          click: function ($event) {
                            return _vm.closePackage(_package.id)
                          },
                        },
                      }),
                    ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.editings[_package.id] != true
                ? _c("div", [
                    _c("h4", [_vm._v(_vm._s(_package.name))]),
                    _vm._v(" "),
                    _c("h5", [
                      _vm._v(
                        _vm._s(_vm.getVendor.local_currency) +
                          _vm._s(_package.rate)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("h6", [_vm._v(_vm._s(_vm.formatPackageDate(_package)))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_package.description))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "badge-wrapper mt-4" },
                      _vm._l(_package.package_tags, function (tag) {
                        return _c(
                          "b-badge",
                          {
                            key: tag.id,
                            attrs: { variant: "info py-1 px-2 m-1" },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(tag.name) +
                                " (" +
                                _vm._s(tag.quantity) +
                                ")\n          "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ])
                : _c(
                    "div",
                    [
                      _c(
                        "info-row",
                        {
                          staticClass: "info-main-row",
                          attrs: { sizing: 2, title: "Name" },
                        },
                        [
                          _c(
                            "b-col",
                            { staticClass: "input-group", attrs: { sm: "12" } },
                            [
                              _c("b-form-input", {
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  title: "Name",
                                  placeholder: "All inclusive",
                                  required: "",
                                },
                                model: {
                                  value: _package.name,
                                  callback: function ($$v) {
                                    _vm.$set(_package, "name", $$v)
                                  },
                                  expression: "_package.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("Taggregator", {
                        ref: "tagsTaggregator",
                        refInFor: true,
                        attrs: {
                          labelKey: "name",
                          label:
                            "select which tags to use for package categories",
                          name: "tags",
                          items: _vm.tags,
                          selections: _vm.selected_tags[_package.id],
                          minimum: 0,
                          quickAddCallback: _vm.quickAddTag,
                          quickAddDescription: "Please provide valid tag name",
                          quickAddMinWordCount: 1,
                          quickAddMinWordLength: 1,
                          quickAddHasUniqueName: true,
                        },
                        on: {
                          "update:selections": function ($event) {
                            return _vm.$set(
                              _vm.selected_tags,
                              _package.id,
                              $event
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "result",
                              fn: function ({ result }) {
                                return [
                                  _c("span", { staticClass: "result-label" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(result.name) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "selection",
                              fn: function ({ selection }) {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "selection-label" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(selection.name) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "selection-quantity ml-4" },
                                    [
                                      _c("b-form-input", {
                                        staticClass: "form-control",
                                        attrs: {
                                          value: _vm.getTagQuantity(
                                            _package.id,
                                            selection.id
                                          ),
                                          type: "number",
                                          title: "Quantity",
                                          placeholder: "Quantity",
                                        },
                                        on: {
                                          input: (v) =>
                                            _vm.setTagQuantity(
                                              _package.id,
                                              selection.id,
                                              v
                                            ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { lg: "12", xl: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Package Rate",
                                    "label-for": "packageRate",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "packageRate",
                                      type: "number",
                                      placeholder: "0.0",
                                    },
                                    model: {
                                      value: _package.rate,
                                      callback: function ($$v) {
                                        _vm.$set(_package, "rate", $$v)
                                      },
                                      expression: "_package.rate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { lg: "12", xl: "8" } }, [
                            _c("p", { staticClass: "sub-header mb-2" }, [
                              _vm._v("Active Dates"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "active-dates mb-3" },
                              [
                                _c("v-date-picker", {
                                  staticClass: "start-date mr-2",
                                  attrs: {
                                    "popover-direction": "bottom",
                                    "popover-align": "left",
                                    mode: "single",
                                    "show-caps": "",
                                    value: _vm.getPackageDate(
                                      _package.starts_at
                                    ),
                                  },
                                  on: {
                                    input: (v) =>
                                      _vm.setPackageDate(index, "starts_at", v),
                                  },
                                }),
                                _vm._v("\n              -\n              "),
                                _c("v-date-picker", {
                                  staticClass: "end-date ml-2",
                                  attrs: {
                                    "popover-direction": "bottom",
                                    "popover-align": "right",
                                    mode: "single",
                                    "show-caps": "",
                                    value: _vm.getPackageDate(_package.ends_at),
                                  },
                                  on: {
                                    input: (v) =>
                                      _vm.setPackageDate(index, "ends_at", v),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Package Description",
                            "label-for": "packageDescription",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "packageDescription",
                              type: "text",
                              placeholder: "Includes all units and items...",
                            },
                            model: {
                              value: _package.description,
                              callback: function ($$v) {
                                _vm.$set(_package, "description", $$v)
                              },
                              expression: "_package.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ])
          }),
          _vm._v(" "),
          _vm.allow_create_new
            ? _c(
                "b-card",
                {
                  staticClass: "mb-2",
                  attrs: { title: "Create New Package" },
                  on: { click: _vm.addPackage },
                },
                [_c("i", { staticClass: "fi-plus cursor-pointer" })]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.requesting
        ? _c("div", { staticClass: "spinner" }, [_c("spinner-loader")], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }